/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@efexteam/components';
import { Country, UserType } from '../../../../configs/language';
import { StepsControl } from '../../constants';
import { useFormData } from '../context';

interface IPersonalInformation {
  formStep: number;
  error?: string;
  errorCode?: string;
  nextFormStep: () => void;
  isSubAccountEnabled?: boolean;
}

interface FormData {
  country: string;
  entity: string;
  isSubAccountEnabled: boolean;
}

const PersonalInformation = ({
  formStep,
  error,
  errorCode,
  nextFormStep,
  isSubAccountEnabled,
}: IPersonalInformation) => {
  const { t } = useTranslation();
  const { setFormValues, data } = useFormData();

  const { country, entity } = data;

  const DROPDOWN_OPTIONS_COUNTRY: { key: string; value: Country }[] = [
    { key: t('mexico'), value: 'MX' },
    { key: t('usa'), value: 'USA' },
  ];

  const [selectedCountry, setSelectedCountry] = useState<Country>(
    DROPDOWN_OPTIONS_COUNTRY[0].value
  );
  const [selectedEntity, setSelectedEntity] = useState<UserType>('Company');

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm<FormData>({ mode: 'all' });

  const onSubmit = handleSubmit(() => {
    setFormValues({
      country: selectedCountry,
      entity: selectedEntity,
      isSubaccount: isSubAccountEnabled,
    });
    nextFormStep();
  });

  useEffect(() => {
    if (country) {
      setSelectedCountry(country as Country);
    }
    if (entity) {
      setSelectedEntity(entity as UserType);
    }
  }, [country, entity]);

  if (formStep !== StepsControl.GeneralInformation) return null;

  return (
    <>
      <Typography variant="h4" className="!my-4 text-center">
        {t('entityMessage')}
      </Typography>

      <form onSubmit={onSubmit} autoComplete="off">
        <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 2, md: 3 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="country">{t('onbRegistryCountry')}</InputLabel>
              <Select
                labelId="country"
                id="country"
                value={selectedCountry}
                label={t('onbRegistryCountry')}
                {...register('country', { required: true })}
                onChange={(e) => setSelectedCountry(e.target.value as Country)}
              >
                {DROPDOWN_OPTIONS_COUNTRY.map((countryOpt) => (
                  <MenuItem key={countryOpt.key} value={countryOpt.value}>
                    {countryOpt.key}
                  </MenuItem>
                ))}
              </Select>
              {errors.country && (
                <p className="text-orange-600">
                  {t('countryOriginValidation')}
                </p>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Typography variant="body2" className="text-orange-600">
                {t(error)}
              </Typography>
            )}
            {errorCode && (
              <Typography variant="body2" className="text-orange-600">
                Code: {errorCode}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} className="flex justify-end">
          <Button
            appearance="primary"
            size="large"
            className="mt-4"
            type="submit"
          >
            {t('regContinue')}
          </Button>
        </Grid>
      </form>
    </>
  );
};

export default PersonalInformation;
